import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import {
  BASIC_SELECT_VALUE_TOOLTIP,
  BASIC_SWITCH_VALUE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.TogglePanels,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'visible',
          label: 'Visible',
          valueComponent: { type: 'Switch' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SWITCH_VALUE_TOOLTIP,
            },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            { key: ComponentConfigType.JsonLogic, value: BASIC_VALUE_TOOLTIP },
          ],
        },
        {
          name: 'direction',
          label: 'Direction',
          valueComponent: {
            type: 'Select',
            options: [
              { label: 'Horizontal', value: 'horizontal' },
              { label: 'Vertical', value: 'vertical' },
            ],
            defaultValue: 'horizontal',
          },
          configTypes: [ComponentConfigType.Value],
          tooltips: [
            {
              key: ComponentConfigType.Value,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
          ],
        },
        {
          name: 'height',
          label: 'Height',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.Variable,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.Variable,
              value: BASIC_SELECT_VALUE_TOOLTIP,
            },
            { key: ComponentConfigType.JsonLogic, value: BASIC_VALUE_TOOLTIP },
          ],
        },
      ],
    },
    {
      title: 'Panels',
      component: 'TogglePanelsConfigPanel',
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
    {
      title: 'Panels Styles',
      component: 'CssSettings',
      props: {
        propsName: 'panelsStyle',
      },
    },
    {
      title: 'Button bar Styles',
      component: 'CssSettings',
      props: {
        propsName: 'buttonBarStyle',
      },
    },
  ],
};
